
import React from "react";

const modules = [
  {
    number: "1",
    title: "O Despertar",
    description: "visão, propósito e primeiros rituais",
    backgroundImage: "/lovable-uploads/e0b3cb15-622e-47e0-b0d3-c22114134bc8.png"
  },
  {
    number: "2",
    title: "Escape do Óbvio",
    description: "rotina e mentalidade de ação",
    backgroundImage: "/lovable-uploads/c8669ace-6a70-450e-a2d0-c9c6362a97ce.png"
  },
  {
    number: "3",
    title: "Domínio Digital",
    description: "renda e posicionamento online",
    backgroundImage: "/lovable-uploads/928bb4f2-9b02-4987-80e9-36dbad7d905d.png"
  },
  {
    number: "4",
    title: "Conteúdo com Presença",
    description: "crie sem vaidade",
  },
  {
    number: "5",
    title: "Corrida",
    description: "ritmo, disciplina e resiliência",
  },
  {
    number: "6",
    title: "Musculação",
    description: "identidade física e consistência",
  },
  {
    number: "7",
    title: "Nutrição Essencial",
    description: "energia, saúde e alta performance",
  },
];

const ModulesSection: React.FC = () => {
  return (
    <section className="section-container" id="modules">
      <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center">
        Um passo de cada vez. Um impacto de cada vez.
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {modules.map((module, index) => (
          <div key={index} className="scroll-reveal">
            {/* Primeiros 3 módulos com imagem sem blur */}
            {index < 3 && module.backgroundImage ? (
              <div className="card-border rounded-lg overflow-hidden">
                <div className="relative">
                  <img
                    src={module.backgroundImage}
                    alt={module.title}
                    className="w-full h-48 object-cover"
                  />
                </div>
                <div className="p-6">
                  <div className="text-3xl font-bold opacity-30 mb-2">{module.number}</div>
                  <h3 className="text-xl font-bold mb-2">{module.title}</h3>
                  <p className="opacity-80">{module.description}</p>
                </div>
              </div>
            ) : (
              /* Módulos restantes com o layout original */
              <div 
                className={`card-border p-6 relative overflow-hidden ${
                  module.backgroundImage ? 'bg-cover bg-center' : ''
                }`}
                style={{
                  backgroundImage: module.backgroundImage ? `url(${module.backgroundImage})` : 'none'
                }}
              >
                {module.backgroundImage && (
                  <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
                )}
                <div className="relative z-10">
                  <div className="text-3xl font-bold opacity-30 mb-2">{module.number}</div>
                  <h3 className="text-xl font-bold mb-2">{module.title}</h3>
                  <p className="opacity-80">{module.description}</p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="text-center mt-16 space-y-4">
        <p className="text-xl opacity-80 scroll-reveal">E muito mais ainda está por vir.</p>
        <p className="text-lg opacity-80 scroll-reveal">
          Cada módulo é desenhado pra construir a melhor versão de quem realmente age — não de quem só sonha.
        </p>
      </div>
    </section>
  );
};

export default ModulesSection;
